import { Component, OnInit, OnChanges, SimpleChanges, Output, Input, ViewChild, ElementRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'alert-content',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
})
export class GlobalAlertComponent implements OnInit, OnChanges {

  @Input() alert: any;
  @Input() alertIndex: number = 0;
  @Input() allAlerts: any[] = [];
  @Output() onClose: any;

  videoUrl: string | null = null;
  isDirectVideo: boolean = false;
  isImage: boolean = false;
  currentAlertIndex: number = 0;
  isLoadingVideo: boolean = false;
  videoKey: number = 0;
  private notificationSound: HTMLAudioElement;
  
  @ViewChild('videoPlayer') videoPlayer: ElementRef<HTMLVideoElement> | undefined;
  
  constructor(private modalService: NgbModal) {
    this.notificationSound = new Audio('assets/audio/notification1.mp3');
  }

  ngOnInit(): void{}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['alertIndex'] || changes['allAlerts'] || changes['alert']) {
      this.currentAlertIndex = this.alertIndex;
      this.updateVideoUrl();
    }
  }

  updateVideoUrl() {
    const currentAlert = this.allAlerts[this.currentAlertIndex] || this.alert;
    if(currentAlert && currentAlert.video){
      this.isImage = this.checkIfImage(currentAlert.video);
      if (this.isImage) {
        this.videoUrl = currentAlert.video;
        this.isDirectVideo = false;
      } else {
        this.isDirectVideo = this.checkIfDirectVideo(currentAlert.video);
        this.videoUrl = this.isDirectVideo ? currentAlert.video : this.convertToEmbedUrl(currentAlert.video);
      }
    } else {
      this.videoUrl = null;
      this.isImage = false;
    }
  }

  checkIfImage(url: string): boolean {
    const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.bmp'];
    return imageExtensions.some(ext => url.toLowerCase().includes(ext));
  }

  get currentAlert() {
    return this.allAlerts[this.currentAlertIndex] || this.alert;
  }

  get hasPrevious(): boolean {
    return this.currentAlertIndex > 0;
  }

  get hasNext(): boolean {
    return this.currentAlertIndex < this.allAlerts.length - 1;
  }

  previousAlert() {
    if (this.hasPrevious) {
      this.currentAlertIndex--;
      this.reloadVideo();
    }
  }

  nextAlert() {
    if (this.hasNext) {
      this.currentAlertIndex++;
      this.reloadVideo();
    }
  }

  private reloadVideo() {
    // Mostrar loader y ocultar video
    this.isLoadingVideo = true;
    
    // Esperar un momento para que el usuario vea el cambio
    setTimeout(() => {
      // Incrementar la clave para forzar recreación del elemento
      this.videoKey++;
      // Actualizar la URL del video
      this.updateVideoUrl();
      // Ocultar loader
      this.isLoadingVideo = false;
    }, 100);
  }

  checkIfDirectVideo(url: string): boolean {
    const videoExtensions = ['.mp4', '.webm', '.ogg', '.mov', '.avi'];
    return videoExtensions.some(ext => url.toLowerCase().includes(ext));
  }

  convertToEmbedUrl(url: string): string {
    const videoIdMatch = url.match(/(?:youtu\.be\/|youtube\.com\/watch\?v=|youtube\.com\/embed\/)([a-zA-Z0-9_-]+)/);
    if (videoIdMatch && videoIdMatch[1]) {
      return `https://www.youtube.com/embed/${videoIdMatch[1]}`;
    }
    return url;
  }

  close(){
    this.onClose.emit(true);
  }

  openDetail(content: any) {
    if (this.alert && this.alert.video) {
        this.playNotificationSound();
        this.modalService.open(content, { centered: true, size: 'lg' });
    }
  }

  private playNotificationSound() {
    this.notificationSound.currentTime = 0;
    this.notificationSound.play().catch(error => {
      console.log('Error playing notification sound:', error);
    });
  }

}
